import { computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

import { isLoadingCommonFilters } from "@signals"

export const adminNewListedTableData = signal([])
export const adminNewListedDetailsData = signal([])
export const adminNewListedDetails = signal({})
export const optionsSelect = signal([])
export const filteredRetailers = signal([])
export const retailerSelected = signal([])
export const adminNewListedSkuMappingData = signal([])

export const adminNewListedShowTable = computed(() => !isLoadingCommonFilters.value && adminNewListedTableData.value.length)
export const adminNewListedShowDetails = computed(() => !isEmpty(adminNewListedDetails.value))